import React from 'react';
import { Textarea } from '@/components/ui/textarea';

import { FormControl } from '@/components/ui/form';

const FormControlArea = ({ field, property, name }) => {
  return (
    <FormControl>
      <Textarea {...field} placeholder={`Enter ${name}`} />
    </FormControl>
  );
};

export default FormControlArea;